import React from 'react'
import Svg from 'src/Components/shared/Svg'

const TeaserEmailSvg = () => (
  <Svg
    width='65'
    height='53'
    viewBox='0 0 65 53'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M36.6413 37.9764L56.4717 22.8912C56.8365 22.6137 57.0472 22.1794 57.0392 21.7216C57.0313 21.2639 56.8055 20.8371 56.4313 20.5725L33.3725 4.26476C32.8735 3.91175 32.2055 3.91175 31.7065 4.26476L8.64766 20.5725C8.27334 20.8372 8.04765 21.2639 8.03968 21.7216C8.0317 22.1794 8.2424 22.6138 8.60721 22.8912L28.4376 37.9764H36.6413Z'
      fill='#9D989B'
    />
    <g filter='url(#filter0_bd)'>
      <path
        d='M10.8435 10.606C10.8435 9.50139 11.7389 8.60596 12.8435 8.60596H54.2575V36.006C54.2575 37.1105 53.3621 38.006 52.2575 38.006H12.8435C11.7389 38.006 10.8435 37.1105 10.8435 36.006V10.606Z'
        fill='#535058'
      />
    </g>
    <rect
      x='15.253'
      y='18.896'
      width='34.692'
      height='2.45'
      rx='1.225'
      fill='#BBB2B7'
      fillOpacity='0.2'
    />
    <rect
      x='15.253'
      y='13.702'
      width='34.692'
      height='2.45'
      rx='1.225'
      fill='#BBB2B7'
      fillOpacity='0.2'
    />
    <rect
      x='22.1141'
      y='23.894'
      width='21.56'
      height='2.45'
      rx='1.225'
      fill='#BBB2B7'
      fillOpacity='0.2'
    />
    <path
      d='M55.6014 53H9.48371C8.6878 53 8.04254 52.3555 8.04254 51.5605V21.6188C8.04254 21.3969 7.58027 22.2595 9.77603 23.7618C13.243 26.4054 28.2666 37.8609 28.2666 37.8609H36.8185L56.5803 22.8373C56.927 22.375 57.0425 22.0283 57.0425 21.6188V51.5605C57.0425 52.3555 56.3973 53 55.6014 53Z'
      fill='#BBB2B7'
    />
    <path
      d='M8.50482 52.4016L28.4724 37.803H36.6127L56.5803 52.4016C56.3204 52.7637 55.8995 53 55.423 53H9.6621C9.18561 53 8.76471 52.7636 8.50482 52.4016Z'
      fill='#B5ADB1'
    />
    <path
      d='M56.5797 52.4016L36.6121 37.803L32.542 37.803V53H55.4224C55.8989 53 56.3198 52.7637 56.5797 52.4016Z'
      fill='#C4BCC5'
    />
    <path
      d='M38.4735 38.4167C38.4735 41.7245 35.8005 44.4034 32.5064 44.4034C29.2123 44.4034 26.5394 41.7245 26.5394 38.4167C26.5394 35.1088 29.2123 32.4299 32.5064 32.4299C35.8005 32.4299 38.4735 35.1088 38.4735 38.4167Z'
      fill='#37393B'
      stroke='#FC5AA6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.7806 39.1341C33.3498 39.1341 33.0005 38.7841 33.0005 38.3524C33.0005 37.9205 33.35 37.5705 33.7806 37.5705C34.2119 37.5705 34.5609 37.9205 34.5609 38.3524C34.5609 38.7841 34.2119 39.1341 33.7806 39.1341ZM31.249 39.1341C30.818 39.1341 30.4687 38.7841 30.4687 38.3524C30.4687 37.9205 30.818 37.5705 31.249 37.5705C31.6801 37.5705 32.0294 37.9205 32.0294 38.3524C32.0294 38.7841 31.6801 39.1341 31.249 39.1341ZM30.4933 41.2359H31.3467H33.677H34.5237C34.8033 41.2359 35.0305 41.0084 35.0305 40.7281V39.8669H35.3277C35.4787 39.8669 35.601 39.7444 35.601 39.5935V38.4877C35.601 38.3366 35.4787 38.2143 35.3277 38.2143H35.0305V37.13C35.0305 36.8499 34.8035 36.6224 34.5237 36.6224H32.6492V36.318C33.0308 36.2566 33.3226 35.9253 33.3226 35.5256C33.3226 35.0823 32.964 34.7231 32.5215 34.7231C32.0791 34.7231 31.7207 35.0823 31.7207 35.5256C31.7207 35.914 31.9958 36.2376 32.3618 36.3119V36.6224H30.4931C30.2135 36.6224 29.9865 36.8496 29.9865 37.13V38.2143H29.6853C29.5345 38.2143 29.4124 38.3369 29.4124 38.4877V39.5935C29.4124 39.7444 29.5347 39.8669 29.6853 39.8669H29.9867V40.7281C29.9867 41.0084 30.2135 41.2359 30.4933 41.2359ZM30.6566 40.1917C30.6566 40.0067 30.8065 39.8568 30.9914 39.8568H34.1088C34.2937 39.8568 34.4436 40.0067 34.4436 40.1917C34.4436 40.3766 34.2937 40.5265 34.1088 40.5265H30.9914C30.8065 40.5265 30.6566 40.3766 30.6566 40.1917Z'
      fill='white'
    />
    <defs>
      <filter
        id='filter0_bd'
        x='-97.8878'
        y='-100.125'
        width='260.877'
        height='246.863'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feGaussianBlur in='BackgroundImage' stdDeviation='54.3656' />
        <feComposite
          in2='SourceAlpha'
          operator='in'
          result='effect1_backgroundBlur'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='5' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_backgroundBlur'
          result='effect2_dropShadow'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow'
          result='shape'
        />
      </filter>
    </defs>
  </Svg>
)

export default TeaserEmailSvg
